<template>
  <div class="needs-detail-container">
    <div class="left-title">{{initTitle}}</div>
    <div class="right-container">
      <slot v-if="slotBtn" name="rightBtn"></slot>
      <div class="btn-container">
        <el-button type="primary" @click="addNewEvent">新增拜访</el-button>
        <el-button
          @click="changeChangeState(true)"
          v-if="userInfo.user_name == detailData.managerUserName"
        >变更状态</el-button>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="更改需求状态"
      width="40%"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="form"
        v-model="selectForm"
        :rules="formRules"
        label-width="80px"
      >
        <el-form-item label="需求状态" required>
          <el-select
            style="width:100%;"
            v-model="selectForm.state"
            placeholder="请选择需求状态"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="button-content">
          <el-button type="primary" @click="saveState">保存</el-button>
          <el-button @click="changeChangeState(false)">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: 'detailTitle',
  data() {
    return {
      id: '',
      dialogVisible: false,
      selectForm: {},
      options: [
        {
          label: '继续跟踪',
          value: '1'
        },{
          label: '需求已转化',
          value: '2'
        },{
          label: '无相关需求',
          value: '3'
        }
      ]
    }
  },
  props: {
    // 详情数据
    detailData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 传入标题， 必须
    initTitle: {
      type: String,
      require: true
    },
    // 是否插入自定义按钮
    slotBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    addNewEvent() {
      this.$emit('addEvent')
    },

    changeChangeState(state) {
      this.dialogVisible = state
    },

    saveState() {
      let self = this
      if(!this.selectForm.state || this.selectForm.state == ''){
        this.$message({
          type: "warning",
          message: "请选择需求状态",
        });
      }else{
        this.$emit('saveState', self.selectForm)
        this.changeChangeState(false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.needs-detail-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 25px;
  .left-title{
    font-size: 18px;
    color: #333;
    font-weight: 700;    
  }
  .button-content{
    text-align: right;
  }
}
</style>